import { Project } from "../../models/project"

export function checkProjectExist(projectId: string, projects: Project[]) {
    return projects.some(p => p.id === projectId)
}
